import { ConsultantEventType } from "@bonliva-crm/graphql";

export enum EventLogTextType {
  Call = ConsultantEventType.Call,
  Comment = ConsultantEventType.Comment
}

export enum EventLogActionType {
  Email = ConsultantEventType.Email,
  SMS = ConsultantEventType.SMS,
  Noanswer = ConsultantEventType.Noanswer,
  Interest = ConsultantEventType.Interest
}

export type EventLogInputType = `${EventLogTextType}` | `${EventLogActionType}`;
